/** @format */

import React, { Component } from 'react';
import { Sidebar, Menu, Icon } from 'semantic-ui-react';
import AppSideMenuItem from './AppSideMenuItem/AppSideMenuItem';
import './AppSideMenu.css';

import { inject, observer } from 'mobx-react';

@inject('SidebarStore', 'UserStore')
@observer
class AppSideMenu extends Component {
  getArrow() {
    const { SidebarStore } = this.props;
    if (SidebarStore.sidebar.open) {
      return <Icon name="chevron left" />;
    } else {
      return <Icon name="chevron right" />;
    }
  }

  renderSidebarItems = () => {
    const { SidebarStore, UserStore } = this.props;
    const isExternal = UserStore.user.isExternal;
    let sidebarItems = !isExternal ? SidebarStore.sidebar.sidebarItems : SidebarStore.sidebar.sidebarItems.filter(item => item.name === 'requests');

    return sidebarItems
      .filter(item => item.user === SidebarStore.sidebar.subMenuActiveItem)
      .map(item => (
        <AppSideMenuItem
          disabled={item.disabled}
          key={item.name}
          handleSideItemClick={() => {
            this.props.handleSideItemClick(item.name, item.link);
            SidebarStore.activeItem(item.name);
          }}
          active={SidebarStore.sidebar.activeItem === item.name}
          name={item.name}
          icon={item.icon}
          link={item.link}
          text={item.text}
        />
      ));
  };

  renderSubMenuSelector = () => {
    const { SidebarStore, UserStore } = this.props;
    const { isAdmin } = UserStore.user;
    if (isAdmin) {
      return (
        <div className="menu-selectors">
          <div
            onClick={() => SidebarStore.setActiveSubMenu('admin')}
            className={
              SidebarStore.sidebar.subMenuActiveItem === 'admin'
                ? 'active menu-selector-item'
                : 'menu-selector-item'
            }
          >
            Admin
          </div>
          <div
            onClick={() => SidebarStore.setActiveSubMenu('operator')}
            className={
              SidebarStore.sidebar.subMenuActiveItem === 'operator'
                ? 'active menu-selector-item'
                : 'menu-selector-item'
            }
          >
            Operatore
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    const { SidebarStore } = this.props;
    return (
      <div>
        <Sidebar.Pushable as="div">
          <Sidebar
            className={SidebarStore.sidebar.disable ? 'disable' : null}
            size="mini"
            as={Menu}
            duration="200"
            animation="push"
            icon="labeled"
            inverted
            vertical
            visible={SidebarStore.sidebar.open}
            width="thin"
          >
            {this.renderSubMenuSelector()}
            {this.renderSidebarItems()}
          </Sidebar>
          <Sidebar.Pusher>
            <div
              className="main-container"
              style={{
                width: SidebarStore.sidebar.open
                  ? 'calc(100% - 150px)'
                  : '100%',
              }}
            >
              {this.props.children}
            </div>
            <div
              className="side-open-button"
              onClick={() => SidebarStore.toggleSidebar()}
            >
              <div className="side-open-arrow">{this.getArrow()}</div>
            </div>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

export default AppSideMenu;
